import { render, staticRenderFns } from "./SmsDetailIncoming.vue?vue&type=template&id=2cd78016&"
import script from "./SmsDetailIncoming.vue?vue&type=script&lang=ts&"
export * from "./SmsDetailIncoming.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports